import { render, staticRenderFns } from "./sk-select-wap.vue?vue&type=template&id=656c992e&"
import script from "./sk-select-wap.vue?vue&type=script&lang=js&"
export * from "./sk-select-wap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports